<nav id=topnav class="navbar topnavbar  topwidth  navbar-expand-lg navbar-light" role="navigation">
    <div class="container-fluid">
        <ul class="navbar-nav mr-auto flex-row">
            <li class="nav-item">
                <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
                <a class="nav-link d-none d-md-block gary-t d-lg-block d-xl-block" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                    <em class="fas fa-bars gary-t"></em>
                </a>
                <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
                <a class="nav-link sidebar-toggle gary-t d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                    <em class="fas fa-bars  gary-t fa-2x"></em>
                </a>
            </li> 
            <li  class="nav-item ml-3">
                 <div class="set-margin page-title">
                    <h1 class="font-28 mt-2 gary-t font600 mb-0 l-h40">{{ headerTitle }}</h1>
                </div>
            </li>
            </ul>

        <!-- <a [routerLink]="['/home/welcomepayg']">

            <div class="brand-logo" *ngIf="paygimage">
                <img class="img-fluid" src="assets/img/logo.png" alt="FastSwiff" />
            </div>

            <div class="brand-logo" *ngIf="image">

                <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                    class="img-fluid image-cropper-container1" src="{{logoimagepath}}" alt="FastSwiff" />
            </div>
        </a> -->
         
         <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDe mb-0
            aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation"
            (click)="isShown = !isShown">
            <span class="navbar-toggler-icon"></span>
        </button> -->
        <!-- <button class="navbar-toggler" type="button" (click)="navCollapsed = !navCollapsed; $event.stopPropagation()">
            <span class="navbar-toggler-icon"></span>
        </button> -->

        <div class="collapse navbar-collapse" [ngClass]="{ 'show': isShown }" id="navbarTogglerDemo03">
            <ul class="navbar-nav  ml-auto">
                <!-- <form class="app-search ">
                    <div class="input-group">
                        <input class="form-control " type="search" placeholder="Search" aria-label="Search">
                        <div class="input-group-append">
                            <button class="btn " type="submit"> <i class="fa fa-search"></i></button>
                        </div>
                    </div>


                </form> -->
                <div class="container-fluid  p-0 in">
                    <div id="navigation" class="active">
                        <!-- Navigation Menu-->
                        <ul class="navigation-menu">
                            <!-- <li class="has-submenu">
                                <div class="box-1">
                                    <input class="type-checkbox" id="toogle" type="checkbox" name="name" (change)="getLive($event)"/>
                                    <label class="estado" for="toogle">
                                        <span class="aprobado" >Live Mode</span>
                                        <span class="desaprobado">Test Mode</span>
                                    </label>
                                </div>        
                            </li> -->
                            <li class="nav-item dropdown dropdown-list" dropdown>
                                <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                                    <img src="assets/img/new/phone-icon.png" alt="" width="17px">
                                     
                                </a>
                                <!-- START Dropdown menu-->
                                <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
                                    <div class="dropdown-item">
                                        <!-- START list group-->
                                        <div class="list-group">
                                           <!-- list item-->
                                           <p class="pt-2 text-center"> Download our app from</p>
                                           <div class="list-group-item list-group-item-action">
                                              <div class="media">
                                                
                                                 <div class="media-body text-center">
                                                  <a href="https://play.google.com/store/apps/details?id=com.xsilica.paygfuturepos" target="_blank"><img width="100px" src="assets/img/new/playstore-btn.png"></a>
                                                 </div>
                                              </div>
                                           </div>
                                           <!-- list item-->
                                           <div class="list-group-item list-group-item-action">
                                              <div class="media">
                                                  
                                                 <div class="media-body text-center">
                                                    <a href="https://apps.apple.com/us/app/payg-future-pos/id1567618603" target="_blank"> <img width="100px" src="assets/img/new/app-store-btn.png"></a>
                                                 </div>
                                              </div>
                                           </div>
                                           
                                        </div>
                                        <!-- END list group-->
                                    </div>
                                </div>
                                <!-- END Dropdown menu-->
                            </li> 
                            <li class="has-submenu" *ngIf="!isLive">
                                <a>
                                    <div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input class="custom-control-input " fxflex="30" id="live" name="standard"
                                                type="radio" value="live" [checked]="!test"
                                                (click)="openConfirmationDialog()">
                                            <label class="custom-control-label" for="live">Live</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input class="custom-control-input" fxflex="30" id="test" name="standard"
                                                type="radio" value="test" [checked]="test" (click)="test1()">
                                            <label class="custom-control-label" for="test">Test</label>
                                        </div>
                                    </div>
                                </a>
                            </li>

                            <!-- <li class="has-submenu" >
                                <form>
                                    <input class="search-h mb-0 mt-3 mr-3" type="search" placeholder="Search">
                                </form>
                            </li> -->
                            <!-- <li class="has-submenu dropdown dropdown-list" dropdown>
                                <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                                    <img src="assets/img/new/message.svg" alt="">
                                    <span class="badge badge-primary">3</span>
                                </a>
                                   
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
                                        <div class="dropdown-item">
                                            
                                            <div class="list-group">
                                             
                                            <div class="list-group-item list-group-item-action">
                                                <div class="media">
                                                    <div class="align-self-start mr-2">
                                                        <em class="fa fa-envelope fa-2x text-warning"></em>
                                                    </div>
                                                    <div class="media-body">
                                                        <p class="m-0">New e-mails</p>
                                                        <p class="m-0 text-muted text-sm">You have 10 new emails</p>
                                                    </div>
                                                </div>
                                            </div>
                                             <div class="list-group-item list-group-item-action">
                                                <div class="media">
                                                    <div class="align-self-start mr-2">
                                                        <em class="fa fa-tasks fa-2x text-success"></em>
                                                    </div>
                                                    <div class="media-body">
                                                        <p class="m-0">Pending Tasks</p>
                                                        <p class="m-0 text-muted text-sm">11 pending task</p>
                                                    </div>
                                                </div>
                                            </div>
                                             <div class="list-group-item list-group-item-action">
                                                <span class="d-flex align-items-center">
                                                    <span class="text-sm">More notifications</span>
                                                    <span class="badge badge-danger ml-auto">14</span>
                                                </span>
                                            </div>
                                            </div> 
                                        </div>
                                    </div>
                                   
                            </li> -->
                            <!-- <li class="has-submenu dropdown dropdown-list" dropdown>
                                <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                                    <img src="assets/img/new/bell.svg" alt="">
                                    <span class="badge badge-primary">11</span>
                                </a>
                                  
                                    <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
                                        <div class="dropdown-item">
                                            
                                            <div class="list-group">
                                           
                                            <div class="list-group-item list-group-item-action">
                                                <div class="media">
                                                    <div class="align-self-start mr-2">
                                                        <em class="fa fa-envelope fa-2x text-warning"></em>
                                                    </div>
                                                    <div class="media-body">
                                                        <p class="m-0">New e-mails</p>
                                                        <p class="m-0 text-muted text-sm">You have 10 new emails</p>
                                                    </div>
                                                </div>
                                            </div>
                                          
                                            <div class="list-group-item list-group-item-action">
                                                <div class="media">
                                                    <div class="align-self-start mr-2">
                                                        <em class="fa fa-tasks fa-2x text-success"></em>
                                                    </div>
                                                    <div class="media-body">
                                                        <p class="m-0">Pending Tasks</p>
                                                        <p class="m-0 text-muted text-sm">11 pending task</p>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div class="list-group-item list-group-item-action">
                                                <span class="d-flex align-items-center">
                                                    <span class="text-sm">More notifications</span>
                                                    <span class="badge badge-danger ml-auto">14</span>
                                                </span>
                                            </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                   
                            </li> -->
                            <li class="has-submenu" *ngIf="isLive">
                                <a href="index.html">
                                    <!-- <i class="fas fa-home"></i> -->
                                    Dashboard
                                </a>
                            </li>
                            <li class="has-submenu" *ngIf="!isLive">
                                <a [routerLink]="['/home/testmode']">
                                    <!-- href="/home/testmode"> -->
                                    <!-- <i class="fas fa-home"></i> -->
                                    Dashboard
                                </a>
                            </li>
                            <!-- menu starts -->
                            <!-- <li class="has-submenu" (click)="isShown = false">
                                <a (click)="submenu = !submenu; $event.stopPropagation()">
                                     
                                    Menu
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu megamenu" [collapse]="submenu" (click)="isShown = false">
                                    <li>
                                        <ul>
                                            <li>
                                                <div class="new-h">
                                                    <h6 class=" p-b3 font-weight-bold">New</h6>
                                                </div>
                                            </li>
                                            <ul *ngIf="PaygsetUphideshow">
                                                <li (click)="isShown = false"> <a
                                                        [routerLink]="['/transactions/new']"><i
                                                            class="fa-1x mr-2 fas fa-dollar-sign"></i>
                                                        Transaction
                                                    </a></li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/futurebilling/new']">
                                                        <i class="fa-1x mr-1 fas fa-money-bill"></i> Recurring Payment
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/invoice/new']">
                                                        <i class="fa-1x mr-1 fas fa-file-invoice"></i>Invoice
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/securevault/new']">
                                                        <i class="fa-1x mr-1 fas fa-lock"></i> TokenEx
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/ecomsolutions/Paynow/new']">

                                                        <img src="assets/img/pay.png" alt="pay"> Pay Button</a>
                                                </li>
                                                
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/addonbusiness/new']">
                                                        <i class="fa-1x mr-1 fas fa-briefcase"></i>EasyCollect
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/ecomsolutions/QuickPay/new']">
                                                        <i class="fa-1x mr-1 fas fa-receipt"></i> Collecting order
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/transactions/faqs']">
                                                        <i class="far fa-1x mr-1  fa-question-circle"></i>Faqs

                                                    </a>
                                                </li>

                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/Coupon/NewCoupons']">
                                                        <i class="fa-1x mr-1 fas fa fa-gift"></i> Coupon
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul *ngIf="payoutgideshow">

                                                <li (click)="isShown = false">
                                                    <a class="welcome-links"
                                                        [routerLink]="['/PayOut/NewPayOutContact']">
                                                        <i class="fas fa-money-bill-wave mr-2"></i>
                                                        PayOut Contact
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a class="welcome-links" [routerLink]="['/PayOut/AccountBalance']">
                                                        <i class="fas fa-rupee-sign mr-2"></i>
                                                        Account Balance
                                                    </a>
                                                </li>
                                               
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">
                                                        <i
                                                        class="fa fa-upload mr-2"></i>
                                                        Bulk File Upload
                                                    </a>
    
                                                </li>
                                            </ul>
                                        </ul>
                                    </li>
                                    <li>
                                        <ul>
                                            <li>
                                                <div class="new-h">
                                                    <h6 class=" p-b3 font-weight-bold">Manage</h6>
                                                </div>
                                            </li>

                                            <ul *ngIf="PaygsetUphideshow">


                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/transactions/manage']"><i
                                                            class="fa-1x mr-2 fas fa-dollar-sign"></i>
                                                        Transaction
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/futurebilling/manage']">
                                                        <i class="fa-1x mr-1 fas fa-money-bill"></i> Recurring Payment
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/invoice/manage']">
                                                        <i class="fa-1x mr-1 fas fa-file-invoice"></i> Invoice
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/securevault/manage']">
                                                        <i class="fa-1x mr-1 fas fa-lock"></i> TokenEx
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/ecomsolutions/Paynow/manage']">

                                                        <img src="assets/img/pay.png" alt="pay"> Pay Button
                                                    </a>
                                                </li>
                                               
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/addonbusiness/manage']">
                                                        <i class="fa-1x mr-1 fas fa-briefcase"></i> EasyCollect
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/ecomsolutions/QuickPay/manage']">
                                                        <i class="fa-1x mr-1 fas fa-receipt"></i> Collecting Order
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/transactions/batch']">
                                                        <i class="fa-1x mr-1 fa fa-table"></i> Settlement
                                                    </a>
                                                </li>
                                               
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/Coupon/ManageCoupons']">
                                                        <i class="fa-1x mr-1 fas fa fa-gift"></i>Coupon
                                                    </a>
                                                </li>
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/Cart/manage']">
                                                        <i class="fa fa-shopping-cart" aria-hidden="true"></i> Cart
                                                        Orders
                                                    </a>
                                                </li>
                                                
                                                <li (click)="isShown = false" *ngIf="isPaymentOrdersAccess">
                                                    <a [routerLink]="['/transactions/orderslist']"><i
                                                            class="fas fa-credit-card mr-2"></i>
                                                        Payment Orders
                                                    </a>
                                                </li>

                                            </ul>
                                            <ul *ngIf="payoutgideshow">
                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/PayOut/ManagePayOutContact']"> <i
                                                            class="fas fa-money-bill-wave mr-2"></i>
                                                        Manage PayOut Contact
                                                    </a>
                                                </li>

                                                <li (click)="isShown = false">
                                                    <a [routerLink]="['/PayOut/PayOutTransactions']"> <i
                                                            class="fas fa-money-bill-alt mr-2"></i>
                                                        PayOut Transactions
                                                    </a>
                                                </li>
                                                
                                            </ul>
                                        </ul>
                                    </li>
                                </ul>
                            </li> -->
                            <!-- meu ends -->
                            <!-- reports ends -->
                            <!-- <li class="has-submenu">
                                <a (click)="reportmenu = !reportmenu; $event.stopPropagation()">
                                   
                                    Reports
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu" [collapse]="reportmenu">
                                    <li>
                                        <ul *ngIf="PaygsetUphideshow">


                                            <li class="has-submenu" (click)="isShown = false">
                                                <a [routerLink]="['/reports/feereport']">Fee Report</a>

                                            </li>
                                            <li class="has-submenu" (click)="isShown = false">
                                                <a [routerLink]="['/reports/paymentledger']">Payment Ledger</a>

                                            </li>
                                          
                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/transactions/currentMonthStatements']">
                                                    Snapshot
                                                </a>
                                            </li>
                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/transactions/merchantStatements']">
                                                    Merchant Statements
                                                </a>
                                            </li>

                                        </ul>
                                    </li>


                                    <li>
                                        <ul *ngIf="payoutgideshow">



                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/PayOut/PayoutLedgers']">
                                                    Payout Ledger
                                                </a>
                                            </li>
                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/PayOut/PayOutBatches']">
                                                    PayOut Settlement
                                                </a>
                                            </li>

                                        </ul>
                                    </li>

                                    <li class="has-submenu" (click)="isShown = false" *ngIf="PaygsetUphideshow">
                                        <a>Transaction Reports <div class="arrow-down"></div></a>
                                        <ul class="submenu">
                                          
                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/reports/transactions/summary']">Transaction summary
                                                    Reports</a>
                                            </li>

                                            <li (click)="isShown = false">
                                                <a [routerLink]="['/transactions/batch']">Settlement Report</a>
                                            </li>

                                           

                                        </ul>
                                    </li>
                                </ul>
                            </li> -->
                            <!-- reports ends -->
                            <!-- settings start -->
                            <!-- <li class="has-submenu" (click)="isShown = false">
                                <a (click)="settingsmenu = !settingsmenu; $event.stopPropagation()">
                                    
                                    Settings
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu" [collapse]="settingsmenu">
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/AuthenticationKey']">Authentication Key</a>
                                    </li>
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/merchantsettings']">Merchant Settings</a>
                                    </li>
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/manage']">User Management</a>
                                    </li>
                                    
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/downloaddocuments']">Download Documents </a>
                                    </li>
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/documentUpload']">Upload Documents </a>
                                    </li>


                                    

                                </ul>
                            </li> -->
                            <!-- settings end -->
                            <!-- Profile Starts -->
                            <li class="has-submenu" (click)="isShown = false">
                                <a (click)="profilemenu = !profilemenu; $event.stopPropagation()">
                                    <img   src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center"id="merchatImage"style="width:36px; height: 36px; padding: 3px; border-radius: 11px; background-color: #e7e8f9"  *ngIf="MerchantLogo">
                                     <img   src="assets/img/user/10.jpg"  style="width: 36px; height: 36px; padding: 3px; border-radius: 11px; background-color: #e7e8f9" *ngIf="PaygLogo">
                                     {{ username}}
                                    <div class="arrow-down"></div>
                                </a>
                                <ul class="submenu" [collapse]="profilemenu">
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/transactions/profile']">Profile</a>
                                    </li>
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/settings/merchantsettings']">Settings</a>
                                    </li>
                                   
                                    <li (click)="isShown = false">
                                        <a [routerLink]="['/login']" (click)="clear()">

                                            <i class="fas fa-sign-out-alt" ></i> Logout


                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <!-- Profile ends -->
                        </ul>
                        <!-- End navigation menu -->

                        <div class="clearfix"></div>
                    </div>
                    <!-- end #navigation -->
                </div>
            </ul>

        </div>
    </div>
</nav>